import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = [ "bridge--toast" ]
  declare readonly bridgeToastOutlet: any
  declare readonly hasBridgeToastOutlet: boolean

  bridgeToastOutletConnected() {
    this.showToast()
  }

  showToast() {
    if (this.hasBridgeToastOutlet && typeof this.bridgeToastOutlet.show === 'function') {
      this.bridgeToastOutlet.show({ 
        stopImmediatePropagation: () => {}, 
        preventDefault: () => {} 
      })
    } else {
      console.warn("ToastAutoShowController: Could not find bridge--toast controller")
    }
  }
}
